<template>
    <div class="container">
        <div class="text-left py-2">
                    <h3>Dashboard</h3>
                    <p>Report for: {{reportDate}}</p>
                </div>
        <div class="row py-3">
            <div class="col-sm-12 col-md-6">
                <div>

                    <select v-model="dayOfWeek" class="form-control">
                        <option value="null" >Filter by day of week</option>
                        <option value="monday">Monday</option>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                        <option value="sunday">Sunday</option>
                    </select>
                    <p>You know you can also see perfomance of your business per day?</p>
                    <small class="text-danger">Please note for this you have to select a date range</small>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <date-range-picker :auto-apply="autoApply" v-model="dateRange" class="custom-width-datepicker"
                    :ranges="false">
                    <template #input="picker" style="width: 100% !important;">
                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ FormatDate(dateRange.startDate) }}
                            - {{ FormatDate(picker.endDate) }}</p>
                        <p v-else><i class="bi bi-calendar-event"></i> Filter by Date</p>
                    </template>
                </date-range-picker>

            </div>
        </div>
        <hr />

        <div class="text-right py-2">

            <a @click="showConsentToDownloadFresh()" class="btn btn-outline-secondary">Download Report <i class="bi bi-download"></i></a>
        </div>

        <div v-if="hasLoaded===true" class="card">
            <div class="card-body">
                <div class="row">
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-graph-up"></i> Sales</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ convertCurrencyToShillings(todaySales) }}</h5>
                        <hr class="m-0 mb-2 mt-1" />
                        <p class="text-dark" v-if="todayPaid > 0" >Paid - {{ convertCurrencyToShillings(todayPaid) }}</p>
                        <p class="text-danger" v-if="todayBalances > 0" ><a :href='"/orders?has-balance=1&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' class="text-danger">Balances - {{ convertCurrencyToShillings(todayBalances) }}</a></p>
                        <p class="text-danger" v-if="todayDiscounts > 0" ><a :href='"/orders?has-discount=1&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' class="text-danger">Discounts - {{ convertCurrencyToShillings(todayDiscounts) }}</a></p>
                        <p class="text-danger" v-if="todayPendingOrders > 0" ><a :href='"/orders?un-attended=1&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' class="text-danger">Pending ({{ todayPendingOrders }}) - {{ convertCurrencyToShillings(todayPendingOrdersValue) }}</a></p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-cash-coin"></i> Profits and Losses</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">
                            P&L
                            <span v-if="(todayProfits -  todayExpenses - totalWastesSum) > 0" class="text-success">{{ convertCurrencyToShillings(todayProfits -  todayExpenses - totalWastesSum) }}</span>
                            <span v-else class="text-danger">({{ convertCurrencyToShillings(todayProfits -  todayExpenses - totalWastesSum) }})</span>
                        </h5>
                        <hr class="m-0 mb-2 mt-1" />
                        <p class="text-dark" >Gross Profit - {{ convertCurrencyToShillings(todayProfits) }}</p>


                        <div v-for="(method,key) in expenseandPaymentsDifference">

                        <p class="text-dark pt-1">{{ key }}:
                            <small>{{ convertCurrencyToShillings(method) }}</small></p>


                        </div>


                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-2 h-100">
                    <div class="text-dark pb-3">
                        <p><i class="bi bi-credit-card"></i> Payment Methods</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />
                        <div v-if="Object.keys(paymentmethods).length">
                            <h5 class="text-dark" style="font-size: 18px; font-weight: 400;" >Received - {{ convertCurrencyToShillings(totalAmountReceived) }}</h5>
                            <hr class="m-0 mb-2 mt-1" />
                            <div v-if="key" v-for="(method,key) in paymentmethods">

                                <p class="text-dark pt-1">{{ key }}:
                                    <small>{{ convertCurrencyToShillings(method) }}</small></p>


                            </div>
                            <a v-b-modal="'all-transactions-modal'" href="#" >View All Transactions</a>
                        </div>

                        <div v-if="hasDukakitPayAccount" >
                            <p>Dukakit Pay Balance - <span class="badge badge-secondary py-1 px-1">{{ convertCurrencyToShillings(dukakitAccountBalance) }}</span></p>
                            <hr class="m-1"/>
                            <div v-if="dukakitAccountBalance > 100" >
                                <p><a v-b-modal="'withdraw-from-dukapay-modal'" class="btn btn-sm btn-primary">Withdraw/Send to M-pesa</a></p>
                                <hr class="m-1"/>
                                <p> Check Transactions</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-cart-check-fill"></i> Expenses & Wastes </p>
                        <hr class="bg-danger m-0 mb-2 mt-1" />

                        <h5 class="text-danger" style="font-size: 18px; font-weight: 400;" v-if="Object.keys(paymentmethods).length">{{ convertCurrencyToShillings(todayExpenses) }}</h5>
                        <hr class="m-0 mb-2 mt-1" />
                           <div v-for="(method,key) in expenseByPayments">

                           <p class="text-danger pt-1" style="font-weight: 400;">{{ key }}:
                               {{ convertCurrencyToShillings(method) }}</p>



                           </div>
                           <div v-if="totalWastesSum > 0">
                                <hr class="m-0 mb-2 mt-1" />
                                <p>Wastes</p>
                                 <p><a class="text-danger" href="/wastes"> Values - {{convertCurrencyToShillings(totalWastesSum)}} </a></p>
                            </div>

                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-cart-check-fill"></i> Orders</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />
                        <h5 class="text-dark" style="font-size: 18px; font-weight: 400;">{{ todayorders }}</h5>
                        <a v-if="todayorders > 0" :href='"/orders?start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate'>View All</a>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 border">
                <div class="py-3 h-100">
                    <div class="text-dark pb-3">
                        <p> <i class="bi bi-box-open"></i>Unique Items Sold</p>
                        <hr class="bg-dark m-0 mb-2 mt-1" />

                        <div v-if="analysisHasLoaded">
                        <h5  class="text-dark" style="font-size: 18px; font-weight: 400;">{{ inventoryAnalysis.length }}</h5>
                        <a href="#" v-b-modal="'inventory-analyis-modal'" v-if="Object.keys(inventoryAnalysis).length > 0">View Inventory Analysis</a>
                     </div>
                        <div v-else class="text-center">
                        <div class="spinner-grow" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        </div>
                        <p  v-b-modal="'inventory-analyis-modal'" > <a  v-if="Object.keys(todayUniqueItems).length > 0"><small>Opening stock, Sold Stock, Remaining stock etc</small></a></p>

                    </div>
                </div>
            </div>
        </div>
            </div>
        </div>
        <div v-else class="card">
            <div class="card-body">
                <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>




        <div class="pt-5 pb-2">
            <h4>Sales Statistics</h4>
        </div>

        <div v-if="hasLoadedGraph===true" class="card">
            <div class="card-body">

                <dashboard-chart :chart-data="chartData" :chart-options="chartOptions"></dashboard-chart>
            </div>
        </div>
        <div v-else class="card">
            <div class="card-body">
                <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="userrole.length >0 && userrole[0] ==='Admin'" class="row mb-5 text-dark">
            <div class="col-md-6 border-right border-primary">
                <div class="py-2">
                    <h2 class="text-bold">Top Performing Employee</h2>
                    <small><i class="bi bi-info-circle"></i>You can click on employees name to see the orders and sum of orders made</small>
                </div>


                <table class="table table-sm table-striped table-hover w-100">
                    <thead>
                        <tr>
                            <td>Employee</td>
                            <td>Total Orders</td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="employee in topemployees">

                            <td>
                                <a :href='"/employees?emp_id=" + employee.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate'>
                                <span class="text-capitalize" v-if="employee.full_name === 'null'">{{ employee.full_name }}</span>
                                    <span class="text-capitalize" v-else>{{ employee.name }}</span>
                                </a>
                            </td>
                            <td>
                                <a :href='"/employees?emp_id=" + employee.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate'>{{ employee.sales }}</a></td>

                        </tr>

                    </tbody>
                </table>


            </div>
            <div class="col-md-6 border-left border-primary">
                <div class="py-2">
                    <h2 class="text-bold">Top 10 Selling Items</h2>
                    <small><i class="bi bi-info-circle"></i>You can click on item to see the item activity over the given period</small>


                </div>

                <table class="table table-sm table-striped table-hover w-100">

                    <tbody>
                        <tr v-for="([key, value],index) in limitedItems" >
                            <td> <a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.quantity}}</a></td>

                        </tr>

                    </tbody>
                </table>
                <a v-b-modal="'all-items-sold-modal'" href="#">Show All Items and Qty</a>

            </div>
        </div>
        <div v-if="userrole.length >0 && userrole[0] !=='Admin'" class="row mb-5 text-dark">

            <div class="col-md-12 border-left border-primary">
                <div class="py-2">
                    <h2 class="text-bold">Top 10 Selling Items</h2>
                    <small>Services</small>
                    <small><i class="bi bi-info-circle"></i>You can click on item to see the item activity over the given period</small>

                </div>

                <table class="table table-sm table-striped table-hover w-100">

                    <tbody>
                        <tr v-for="([key, value],index) in limitedItems" >
                            <td> <a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + value.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ value.quantity}}</a></td>

                        </tr>

                    </tbody>
                </table>
                <a v-b-modal="'all-items-sold-modal'" href="#">Show All Items and Qty</a>


            </div>
        </div>
        <hr />
        <b-modal size="lg" id="all-items-sold-modal" hide-footer>
            <div class="text-center">
                <h5 v-if="selectedStartDate !=='' && selectedEndDate !==''">All Items and Quanties Sold on {{ selectedStartDate }} - {{ selectedEndDate }}</h5>
                <h5 v-else>All Items and Quanties Sold</h5>
                <hr />


                 </div>
            <table class="table table-striped">
                <thead>

                    <td>Item</td>
                    <td>Quanties Sold</td>

                </thead>
                <tbody>
                    <tr v-for="(key, value) in topitems" >
                            <!-- <td>{{ index + 1 }}</td> -->
                            <td> <a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + key.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ key.title }}</a></td>
                            <td><a class="text-dark" :href='"/inventory-activity?only-sales=1&p-identifier-id=" + key.id + "&start-date=" +  selectedStartDate + "&end-date=" + selectedEndDate' >{{ key.quantity}}</a></td>



                        </tr>
                </tbody>
            </table>

        </b-modal>
        <b-modal size="lg" id="inventory-analyis-modal" hide-footer>
            <div class="text-center">
                <h5>Inventory and Stock Analysis</h5>
                <hr />
                <div class="text-right my-1">
                    <a class="btn btn-outline-secondary" @click="downloadInventoryAnalysis">Download Stock Analysis <i class="bi bi-download"></i></a>

                </div>

                 </div>
            <table class="table table-striped table-responsive">
                <thead>
                    <td>#</td>
                    <td>Item</td>
                    <td>Opening Stock</td>
                    <td>Remaining</td>
                    <td>Restock Count</td>
                    <td>Sold Qty</td>
                </thead>
                <tbody>
                    <tr v-for="(inventory,key) in inventoryAnalysis">
                    <td>{{ key + 1 }}</td>
                    <td>{{ inventory.product.product }}</td>
                    <td>{{ inventory.opening_stock_balance }}</td>
                    <td>{{ inventory.product.remaining_units }}</td>
                    <td>{{ inventory.restock_count }}</td>
                    <td>{{ inventory.sold_qty }}</td>
                    <td></td>
                    </tr>
                </tbody>
            </table>

        </b-modal>
        <b-modal size="lg" id="all-transactions-modal" hide-footer>
            <div class="text-center">
                <h5>Transactions -  {{ convertCurrencyToShillings(totalAmountReceived) }}</h5>
                        <hr class="m-0 mb-2 mt-1" />
                        <div v-if="key" v-for="(method,key) in paymentmethods">

                            <p class="text-dark pt-1">{{ key }}:
                                <small>{{ convertCurrencyToShillings(method) }}</small></p>


                        </div>

                 </div>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Order</th>
                        <th>Amount</th>
                        <th>Mode</th>
                        <th>Order Date</th>
                        <th>Payment Date</th>
                    </tr>

                </thead>
                <tbody>
                    <tr v-if="trx" v-for="(trx,key) in allTransactions">
                    <td>{{ key + 1 }}</td>
                    <td><a title="View order" :href="'/orders?order-number=' + trx.id + 'source=/dashboard'">{{ trx.order }}</a></td>
                    <td>{{ convertCurrencyToShillings(trx.amount) }}</td>
                    <td>{{ trx.paymentMethod }}</td>
                    <td>{{ trx.order_date }}</td>
                    <td>{{ trx.trx_date }}</td>
                    <td></td>
                    </tr>
                </tbody>
            </table>
        </div>

        </b-modal>
        <b-modal id="withdraw-from-dukapay-modal" hide-footer>
            <div class="text-center" v-if="!withdrawal.messageToWithdraw">
            <h4>Send to M-pesa</h4>

            <p>The amount will be sent to M-pesa number</p>
            <hr />
            <form @submit.prevent="withdrawToMpesa">
                <div class="form-group">
                    <vue-tel-input :placeholder="712345678" v-model="withdrawal.phone"></vue-tel-input>

                </div>
                <div class="form-group">
                    <input class="form-control" type="number" placeholder="Enter amount" v-model="withdrawal.amount" />

                </div>
                <div class="form-group">
                    <p class="text-left">Reason </p>
                    <textarea class="form-control"v-model="withdrawal.reason"></textarea>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary">Continue to Withdraw</button>

                </div>

            </form>
        </div>
        <div class="text-center" v-else>
            <p><span class="h2"><i class="bi bi-check2-circle"></i></span></p>
            <p class="py-3" v-html="withdrawal.messageToWithdraw"></p>
        </div>
        </b-modal>


    </div>

</template>

<script>
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import DashboardChart from "../analytics/charts/dashboardsales.vue";
    import {mapGetters} from 'vuex';
    export default {
        name: "sales",
        components: {
            DateRangePicker,
            DashboardChart
        },
        props: ['userrole'],
        data() {
            return {
                paymentmethods: '',
                todaySales: 0,
                todayPaid: 0,
                todayBalances: 0,
                todayDiscounts : 0,
                todayPendingOrders : 0,
                todayPendingOrdersValue : 0,
                todayExpenses: '',
                todayProfits: '',
                todayorders: '',
                todayUniqueItems: '',
                topcategories: '',
                expenseByPayments:'',
                expenseandPaymentsDifference:'',
                topitems: [],
                topemployees: '',
                totalAmountReceived: '',
                allTransactions: '',
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                chartData: {
                    labels: [],
                    datasets: []
                },
                dayOfWeek:null,
                chartOptions: {
                    responsive: true
                },
                graphData: {
                    sales: [],
                    timeofday: []
                },
                autoApply: true,
                inventoryAnalysis:{},
                hasLoaded:false,
                hasLoadedGraph:false,
                analysisHasLoaded:false,
                totalWastesSum:0,
                selectedStartDate:'',
                selectedEndDate:'',
                dukakitAccountBalance:0,
                hasDukakitPayAccount:true,
                newReport:0,
                withdrawal:{
                    amount:'',
                    phone:'',
                    messageToWithdraw:false,
                    reason:'',
                }
            }
        },
        computed: {
            ...mapGetters(['userDetails']),

                limitedItems() {

                    const itemsArray = Object.entries(this.topitems);

                    return itemsArray.slice(0, 10);

                },
                 reportDate() {
                    const urlParams = new URLSearchParams(window.location.search);
                    const daySelected = urlParams.get('day-of-week') || "Today";
                    const startDate = urlParams.get('start-date');
                    const endDate = urlParams.get('end-date');
                    let selectedDate;

                    if (startDate && endDate) {
                        const formattedStartDate = new Date(startDate).toLocaleDateString('en-US');
                        const formattedEndDate = new Date(endDate).toLocaleDateString('en-US');
                        selectedDate = `${formattedStartDate} To ${formattedEndDate}`;
                    } else {
                        const today = new Date().toLocaleDateString('en-US');
                        selectedDate = `Today - ${today}`;
                    }

                    if (daySelected === "Today") {
                        return selectedDate;
                    }

                    return `${selectedDate}, focusing on ${daySelected.charAt(0).toUpperCase() + daySelected.slice(1)}s`;
                }
            },
        watch: {

         dateRange: {
             deep: true,
             handler(after, before) {
                 const urlParams = new URLSearchParams(window.location.search);
                 if (after.startDate && after.endDate) {

                     const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                     const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                     urlParams.set('start-date', startDateString);
                     urlParams.set('end-date', endDateString);
                     this.selectedStartDate = startDateString
                     this.selectedEndDate = endDateString


                  }
                  window.history.replaceState(null, null, '?' + urlParams.toString());

                 this.getHighlights()
                 this.displayData()
                 this.getInventoryAnalysis()
                 }
             },
             dayOfWeek: {
    handler(after) {
        const urlParams = new URLSearchParams(window.location.search);

        if (after) {
            // Set the day-of-week in the URL
            urlParams.set('day-of-week', after);

            // Check if start-date and end-date are not set
            if (!urlParams.get('start-date') || !urlParams.get('end-date')) {
                const today = new Date();
                const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

                // Format dates as MM/DD/YYYY
                const formattedStartDate = startOfMonth.toLocaleDateString('en-US');
                const formattedEndDate = today.toLocaleDateString('en-US');

                // Update URL parameters
                urlParams.set('start-date', formattedStartDate);
                urlParams.set('end-date', formattedEndDate);

                // Update the local dateRange data
                this.$set(this.dateRange, 'startDate', startOfMonth);
                this.$set(this.dateRange, 'endDate', today);
            }
        } else {
            // Remove day-of-week if it's cleared
            urlParams.delete('day-of-week');
        }

        // Update the URL without reloading the page
        window.history.replaceState(null, null, '?' + urlParams.toString());

        // Trigger relevant data updates
        this.getHighlights();
        this.displayData();
        this.getInventoryAnalysis();
    },
},


     },
        methods: {
            withdrawToMpesa() {
                axios.post('/api/dukakit-account/withdraw', {...this.withdrawal}).then(results=>{
                    if(results.status === 200 && results.data.type === 'success')
                    {
                        this.$toasts.push(
                                {
                                    'type':'success',
                                    'message':'Your request has been received and being processed. You will receive notification',
                                }
                            )
                            this.withdrawal.messageToWithdraw = "Your request is being processed"

                        setTimeout(() => {

                            window.location.href='/dashboard'
                        }, 6000);

                    }

                })
            },
            showConsentToDownloadFresh() {
                    this.boxTwo = ''
                    this.$bvModal.msgBoxConfirm('To avoid duplication and save time, we automatically back up your report the first time it is downloaded for the specified period. If you`d like a refreshed version, please click below to generate a new report.', {
                    title: 'Generate report',
                    size: 'lg',
                    buttonSize: 'md',
                    okVariant: 'danger',
                    okTitle: 'Download Report',
                    cancelTitle: 'Generate New Report',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                    })
                    .then(value => {
                        if(value === false)
                        {
                            this.newReport = 1
                        }
                        else
                        {
                            this.newReport = 0
                        }
                        this.downloadReport()
                    })
                    .catch(err => {
                        // An error occurred
                    })
            },
            async downloadReport()
            {
                const urlParams = new URLSearchParams(window.location.search);
                await axios.get('/api/reports-daily', {
                        params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),
                            from_dashboard:true,
                            new_report: this.newReport,
                        },
                        // responseType: 'blob'
                    })
                    .then(response => {
                        if(response.status === 200)
                        {
                            // const url = window.URL.createObjectURL(new Blob([response.data]));
                            // const link = document.createElement('a');
                            // const fileName = moment().format('HMY-is');
                            // link.href = url;
                            // link.setAttribute('download', 'Report-' + fileName +'.pdf');
                            // document.body.appendChild(link);
                            // link.click();
                            this.$bvModal.msgBoxConfirm('We will send you the report on your email - '+ this.userDetails.email , {
                                title: 'Report Request received',
                                size: 'md',
                                buttonSize: 'md',
                                okVariant: 'success',
                                okTitle: 'Ok Waiting!',
                                cancelTitle: 'Close',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                                })
                                .then(value => {

                                })
                                .catch(err => {

                                })

                        }
                        else{
                            this.$toasts.push(
                                {
                                    'type':'error',
                                    'message':' There was an error CODE - ' + response.status,
                                }
                            )
                        }

                    })
                    .catch(error => {

                    });
            },
            displayData() {
                // let uri = 'api/analytics/sales';
                let Sales = [];
                let Timeofday = [];
                this.hasLoadedGraph = false
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/analytics-sales', {
                    params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),


                        }
                    })
                    .then(result => {
                        $.each(result.data, function(key, value) {
                            Timeofday.push(key);
                            Sales.push(value)
                        });
                        this.chartData = {
                            labels: Timeofday,
                            datasets: [{
                                label: 'Data as from ' + this.FormatDate((this.dateRange.startDate === null) ? ((this.selectedStartDate ==='') ? moment() : this.selectedStartDate) : this.dateRange.startDate ) + ' to ' +
                                    this.FormatDate((this.dateRange.endDate === null) ?  ((this.selectedEndDate ==='') ? moment() : this.selectedEndDate) : this.dateRange.endDate),
                                backgroundColor: '#fd4719',
                                data: Sales
                            }]
                        }
                        this.hasLoadedGraph = true
                    }).catch(error => {
                        // what now?
                    })
            },
            getDukakitPayAccountBalance() {
                axios.get('/api/dukakit-account/balance')
                    .then(results => {
                        if (results.status === 200) {
                            this.dukakitAccountBalance = results.data;
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 433) {
                            this.hasDukakitPayAccount = false;
                        } else {

                        }
                    });
            },

            getInventoryAnalysis() {
                this.analysisHasLoaded = false;
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/inventory-analysis', {
                    params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),

                        }
                    })
                    .then(result => {
                        this.inventoryAnalysis = result.data
                        this.analysisHasLoaded = true
                    }).catch()
                },
            getHighlights() {

                this.hasLoaded = false
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/highlights', {
                        params: {
                            start_date:  urlParams.get('start-date'),
                            end_date: urlParams.get('end-date'),
                            day_of_week: urlParams.get('day-of-week'),

                        }
                    })
                    .then(result => {
                        if (result.status === 200) {
                            this.todayExpenses = result.data.expenses;
                            this.todayorders = result.data.orders;
                            this.todayUniqueItems = result.data.uniqueItems;
                            this.paymentmethods = result.data.payments;
                            this.topemployees = result.data.employees;
                            this.topitems = result.data.items;
                            this.todaySales = result.data.sales;
                            this.todayBalances = result.data.balances;
                            this.todayPaid = result.data.paid;
                            this.todayProfits = result.data.profits;
                            this.todayDiscounts = result.data.discounts;
                            this.todayPendingOrders = result.data.pending;
                            this.todayPendingOrdersValue = result.data.pendingValue;
                            this.expenseByPayments = result.data.expensePayments;
                            this.expenseandPaymentsDifference = result.data.expenseandPaymentsDifference;
                            this.totalAmountReceived = result.data.totalAmountReceived;
                            this.allTransactions = result.data.allTransactions;
                            this.totalWastesSum = result.data.wastes;
                        }
                        this.hasLoaded = true;
                    }).catch(err => {

                    })
            },
            downloadInventoryAnalysis()
            {
                const urlParams = new URLSearchParams(window.location.search);
                axios.get('/api/download-inventory-analysis', {
                    params: {
                        start_date: urlParams.get('start-date'),
                        end_date: urlParams.get('end-date')
                    },
                    responseType: 'blob'
                    })
                    .then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    const fileName = 'Inventory-analysis-' + moment().format('H-I-M-Y') + '.xlsx';
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    })
                    .catch(error => {
                    console.error("Download error:", error);
                    });

            },
            FormatDate(date) {
                let finaldate = moment(date).format('DD-MMM-YYYY');
                return finaldate;
            },
        },
        mounted() {

            this.getDukakitPayAccountBalance()
            this.getHighlights();
            this.displayData();
            this.getInventoryAnalysis();
            },

    }
</script>

<style scoped>
    .bg-success-light {
        background: #daf3d9;
    }
    .bg-dark-light {
        background: #e0e0e0;
    }
    .bg-danger-light {
        background: #efdcdb;
    }
    .bg-primary-light {
        background: #badaf5;
    }
</style>
